// import { ToastComponent } from "./../../components/toast/toast";
import { WebPushNotificationsService } from "./../../providers/web-push/web-push-notifications.service";
import { WebPushProvider } from "./../../providers/web-push/web-push";

import {
  Component,
  OnInit,
  Injector,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  App,
  ToastController,
  Platform,
} from "ionic-angular";
import { User } from "../../providers/user/user";
import { BasePageComponent } from "../../components/base-page/base-page";
import { HomeNav } from "../../enums/enums";
import { canEnterIfAuthenticated } from "./../../decorators/index";
import { Log, Level } from "ng2-logger/client";
import { FcmProvider } from "../../providers/fcm/fcm";
import { tap } from "rxjs/operators";
import { MessengerPage } from "../messenger/messenger";
import { ContactRequestPage } from "../contact-request/contact-request";
import { CurrentEventProvider } from "../../providers/current-event/current-event";
import { MessagePage } from "../message/message";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { EventInfoProvider } from "../../providers/event-info/event-info";
import { isPlatformBrowser } from "@angular/common";

/**
 * Generated class for the HomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@canEnterIfAuthenticated
@IonicPage()
@Component({
    selector: 'page-home',
    templateUrl: 'home.html',
})
export class HomePage extends BasePageComponent {
    segmentNav = HomeNav;
    events: HomeNav = this.segmentNav.feeds;

    appPaused: boolean;
    firebasePlugin;

    constructor(
        public app: App,
        public navCtrl: NavController,
        public navParams: NavParams,
        public userService: User,
        public injector: Injector,
        private platform: Platform,
        private fcm: FcmProvider,
        private toastController: ToastController,
        private currentEventProvider: CurrentEventProvider,
        private analyticsProvider: AnalyticsProvider,
        private eventInfoProvider: EventInfoProvider,
        private webPush: WebPushProvider,
        private webPushNotificationsService: WebPushNotificationsService,
        @Inject(PLATFORM_ID) private platformId: Object

    ) {
        super(app, navCtrl, userService, navParams);
        if (this.navParams.get('events')) {
            this.events = this.navParams.get('events');
        }

        platform.ready().then(() => {
            this.firebasePlugin = (<any>window).FirebasePlugin;
          });
    }

    ngOnInit() {
        // this.navCtrl.setRoot('EventMasterPage', {
        //   pin: 10013,
        // });
        const log = Log.create('Home Component');
        log.i('Welcome to home componentn');
        // We need this to know on which events user is admin
    }

  ngAfterViewInit() {
    console.log(this.platformId, isPlatformBrowser(this.platformId));

    if (isPlatformBrowser(this.platformId)) {
      // this.webPushNotificationsService.setToastComponent(this.toastComponent);
      this.webPushNotificationsService.requestPermissionAndGetToken();
    }
  }

  ionViewDidLoad() {
    //log page view
    this.analyticsProvider.trackScreenView("Home Page");
    this.fcm.initializeToken();

        console.log("Home page view loaded.");
        this.canView();
        if (this.platform.is('cordova')) {

            console.log('INIT TOKEN');
            this.fcm.initializeToken();

            // this.firebasePlugin.onTokenRefresh().subscribe((token) => {
            //     console.log('REFRESH TOKEN', token)
            //     this.fcm.saveToken(token);
            // });
            this.firebasePlugin.onTokenRefresh((token) => {
                console.log('REFRESH TOKEN', token)
                this.fcm.saveToken(token);
            })

            this.fcm.listenToNotifications().pipe(
                tap(
                    data => {

                        const toast = this.toastController.create({
                            message: data.body,
                            duration: 3000
                        });

                        console.log("NOTIFICATION RECEIVED: " + data);

                        toast.present().then(() => {
                            if (data && data.tap == "foreground") {
                            // if (data && data.tap == true) {
                                this.showPage(data, data.type, data.pin);
                            }
                        })
                    }
                )
            ).subscribe(() => console.log('SUBSCRIBED TO NOTIFICATIONS'));

        }
    }

    showPage(data, notificationType: string, pin: string) {
        console.log('NOTIFICATION CAME', notificationType, pin)
        switch (notificationType) {
            case "NEW_MESSAGE":
                this.navCtrl.push('MessagePage', {
                    userId: data.senderId
                });
                break;
            case "FRIEND_REQUEST":
                this.navCtrl.push(ContactRequestPage);
                break;
            case "POST_PUBLISHED":
                this.navCtrl.push('EventDetailsPage', {
                    pin: pin,
                });
                break;
            case "COMMUNITY":
                this.navCtrl.push('EventDetailsPage', {
                    pin: pin,
                });
                break;
            case "POST_COMMENT":
                this.navCtrl.push('EventDetailsPage', {
                    pin: pin,
                    postId: +data.postId
                });
                break;
            case "FRIEND_REQUEST_ACCEPTED":
                this.navCtrl.push('ProfilePage', {
                    userId: data.senderId
                });
                break;
        }
    }

    swipeEvent(e) {
        if (e.direction === 2) {
            if (this.events < 3) this.events++;
        } else if (e.direction === 4) {
            if (this.events > 1) this.events--;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts